(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-home-film')) {
    customElements.define('ks-home-film', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.video.dataset.src || !this.button) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          this.video.paused ? this.playFilm() : this.video.pause();
        }, options);
        this.video.addEventListener('playing', () => { this.setAttribute('data-ready', ''); this.updateControl(); }, options);
        this.video.addEventListener('pause', () => this.updateControl(), options);
        this.video.addEventListener('error', () => { this.removeAttribute('data-ready'); this.button.hidden = true; }, options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.video.pause(); }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); }, options);
        const autoStart = async () => {
          const connection = navigator.connection;
          if (document.readyState !== 'complete' || !this.inView || this.autoAttempted || !matchMedia('(min-width: 1000px)').matches || this.motion.matches || connection?.saveData || /2g/.test(connection?.effectiveType || '') || this.userPaused || document.hidden) return;
          this.autoAttempted = true;
          try { await this.querySelector('img')?.decode(); } catch (_) {}
          if (this.isConnected && this.inView && !this.motion.matches && !this.userPaused) this.playFilm();
        };
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (!this.inView) this.video.pause();
          else autoStart();
        }, { threshold: .15 });
        this.observer.observe(this);
        if (document.readyState === 'complete') autoStart();
        else window.addEventListener('load', autoStart, { ...options, once: true });
      }
      async playFilm() {
        if (!this.video.src) this.video.src = matchMedia('(max-width: 699px)').matches ? this.video.dataset.mobileSrc : this.video.dataset.src;
        this.video.muted = true;
        try { await this.video.play(); } catch (_) { this.updateControl(); }
      }
      updateControl() {
        this.button.textContent = this.video.paused ? this.dataset.play : this.dataset.pause;
        this.button.setAttribute('aria-pressed', String(!this.video.paused));
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); this.initialized = false; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
